export default __webpack_public_path__ + "static/media/ireland.9148bddf.svg";